import { render, staticRenderFns } from "./DetailSalesOrder.vue?vue&type=template&id=c67b7324&scoped=true&"
import script from "./DetailSalesOrder.vue?vue&type=script&lang=js&"
export * from "./DetailSalesOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailSalesOrder.vue?vue&type=style&index=0&id=c67b7324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b7324",
  null
  
)

export default component.exports